export const ACTIVATION_CHANNELS = {
  SET_LAYOUT: 'SET_LAYOUT',
  SET_SELECTED_PLATFORM: 'SET_SELECTED_PLATFORM',
  SET_SELECTED_CRED: 'SET_SELECTED_CRED',
  SET_SEARCH_TEXT: 'SET_SEARCH_TEXT',
};
